import { Box, Group } from '@mantine/core';

import { NAVBAR_HEIGHT } from '../../shared/components/UI/Navbar/Navbar';

import { useStreamsQuery } from '../../features/streams/components/forms/hooks/streams.hook';
import { useRedirectToFirstStream } from '../../features/streams/components/forms/hooks/useRedirectToFirstStream.hook';
import { EmptyStreamPlaceholder } from '../../features/streams/components/listOfResults/EmptyStreamPlaceholder';
import { ListOfResults } from '../../features/streams/components/listOfResults/ListOfResults';
import Sidebar from '../../features/streams/components/sidebar/Sidebar';

const SIDEBAR_WIDTH = 284;

export default function StreamPage() {
  useRedirectToFirstStream();

  const streamsQuery = useStreamsQuery();

  if (streamsQuery.data.streams.length === 0) {
    return <EmptyStreamPlaceholder />;
  }

  return (
    <Group
      h="100%"
      mah={`calc(100vh - ${NAVBAR_HEIGHT}px)`}
      sx={{ overflow: 'hidden' }}
    >
      <Sidebar width={SIDEBAR_WIDTH} />
      <Box
        h="100%"
        w={`calc(100% - ${SIDEBAR_WIDTH}px)`}
        ml={`${SIDEBAR_WIDTH}px`}
      >
        <ListOfResults />
      </Box>
    </Group>
  );
}
